import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/CTA/CTA.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/actions-runner/_work/website/website/components/Double/Double.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/actions-runner/_work/website/website/components/GenericHero/GenericHero.js");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/node_modules/next/dist/client/link.js");
